function loadBadgesPlp(unique_wrapper, productTags){
    if (!unique_wrapper) return;

    const storeData = sessionStorage.getItem('store');
    if (!storeData) return;

    let session;
    try {
        session = JSON.parse(storeData);
    } catch (e) {
        console.error('Error parsing session store:', e);
        return;
    }

    if (!session || !session.data || !session.data.metaobjects || !session.data.metaobjects.nodes) return;

    const metaobjects = session.data.metaobjects.nodes;

    for (let i = 0; i < metaobjects.length; i++) {
        const element = metaobjects[i];
        const tagField = element.fields.find(item => item.key === 'tag');
        
        if (!tagField) continue;
        
        const metaTag = tagField.value;

        // Check if this metaobject's tag is in the product's tags and contains 'condition'
        if (productTags.includes(metaTag) && metaTag.indexOf('condition') !== -1) {
            // Get metaobject fields
            const metaObject = element['fields'].reduce((obj, item) => {
                obj[item.key] = item.value;
                return obj;
            }, {});

            const hasPromotionWindow = Boolean(metaObject.promotion_start_date || metaObject.promotion_end_date);

            if (hasPromotionWindow) {
                continue;
            }

            let isActiveCampaign = false;
            const showBadge = metaObject.add_badge_to_product_picture;

            // If the campaign has a start and end date, check if it is active
            if (metaObject.promotion_start_date && metaObject.promotion_end_date) {
                const currentDate = new Date();
                const startDate = new Date(metaObject.promotion_start_date);
                const endDate = new Date(metaObject.promotion_end_date);
                isActiveCampaign = currentDate >= startDate && currentDate <= endDate;
            } else {
                // If the campaign has no start and end date, it is always active
                isActiveCampaign = true;
            }

            if (isActiveCampaign === true && showBadge === 'true') {
                // DUPLICATE CHECK: Check if badge already exists in this wrapper
                const existingBadge = unique_wrapper.querySelector(`.mm-badge-label[title="${metaObject.badge}"]`);
                if (existingBadge) continue;

                // Create new badge element
                const newBadge = document.createElement('div');
                newBadge.className = 'mm-badge';
                // Create inner badge element
                const span = document.createElement('span');
                span.className = 'mm-badge-label';
                span.title = metaObject.badge;
                span.textContent = metaObject.badge;
                // Add badge inner element

                newBadge.appendChild(span);

                unique_wrapper.appendChild(newBadge)
            }
        }
    }
}